import { toast } from "sonner";

export const SALES_NOTIFY_EVENT_WA = "sales:wa-new";
export const SALES_NOTIFY_EVENT_LEAD = "sales:lead-new";

let audioCtx;

export function playAlertSound() {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    if (!audioCtx) audioCtx = new Ctx();
    if (audioCtx.state === "suspended") audioCtx.resume();
    const now = audioCtx.currentTime;
    const osc = audioCtx.createOscillator();
    const gain = audioCtx.createGain();
    osc.type = "sine";
    osc.frequency.setValueAtTime(880, now);
    osc.frequency.setValueAtTime(1174, now + 0.12);
    gain.gain.setValueAtTime(0.0001, now);
    gain.gain.exponentialRampToValueAtTime(0.12, now + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.28);
    osc.connect(gain);
    gain.connect(audioCtx.destination);
    osc.start(now);
    osc.stop(now + 0.3);
  } catch {
    /* ignore autoplay blocks until a click unlocks AudioContext */
  }
}

export function notifyInApp({ title, description, href }) {
  toast(title, {
    description,
    duration: 8000,
    action: href
      ? {
          label: "Open",
          onClick: () => { window.location.href = href; },
        }
      : undefined,
  });
}

export function notifyBrowser({ title, body, href }) {
  if (typeof window === "undefined" || !("Notification" in window)) return;
  if (Notification.permission !== "granted") return;
  try {
    const n = new Notification(title, {
      body: body || "",
      icon: "/favicon.ico",
      tag: `${title}-${body || ""}`.slice(0, 80),
    });
    n.onclick = () => {
      window.focus();
      if (href) window.location.href = href;
      n.close();
    };
  } catch {
    /* ignore */
  }
}

export function alertNew({ kind, title, body, href }) {
  playAlertSound();
  notifyInApp({ title, description: body, href });
  notifyBrowser({ title, body, href });
  const ev = kind === "lead" ? SALES_NOTIFY_EVENT_LEAD : SALES_NOTIFY_EVENT_WA;
  window.dispatchEvent(new CustomEvent(ev, { detail: { title, body, href } }));
}

export function notificationPermission() {
  if (typeof window === "undefined" || !("Notification" in window)) return "unsupported";
  return Notification.permission;
}

export async function requestNotificationPermission() {
  if (typeof window === "undefined" || !("Notification" in window)) return "unsupported";
  if (Notification.permission === "granted") return "granted";
  try {
    return await Notification.requestPermission();
  } catch {
    return Notification.permission;
  }
}
